// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { type DashMiddleware, type DashNext, type DashStore } from '@makemydeal/dr-shared-store';

// consts/enums
import { VAUTO_APPRAISALS_SUCCESS } from '../actionTypes/vAutoActionTypes';

// utils
import { mapTradeInsToAppraisals } from '../utils/vAutoUtils';

// actions
import { getVAutoTriforceData } from '../actions/vAutoTriforceActionCreators';
import type { VAutoItem } from '@makemydeal/dr-dash-types';

export const middleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    if (action.type === VAUTO_APPRAISALS_SUCCESS) {
        const vAutoAppraisal: VAutoItem[] = action.payload.data?.items ?? [];
        if (!vAutoAppraisal.length) {
            return next(action);
        }

        const state = store.getState();

        const multiTradeInAppraisals = mapTradeInsToAppraisals(state, vAutoAppraisal);
        multiTradeInAppraisals.forEach(({ appraisal, vin }) => {
            if (vin && appraisal?.id) {
                store.dispatch(getVAutoTriforceData(appraisal.id));
            }
        });
    }

    return next(action);
};
